import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import type { MaintenanceWindow } from "../types";

interface Props {
  upcoming: MaintenanceWindow;
}

function formatCountdown(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes > 0) return `${minutes} min ${seconds} s`;
  return `${seconds} s`;
}

function formatCountdownRough(ms: number): string {
  // For deployment windows we don't know the exact moment of the actual outage —
  // round up to the nearest minute and drop seconds.
  const minutes = Math.max(1, Math.ceil(ms / 60000));
  return `${minutes} min`;
}

export function MaintenanceBanner({ upcoming }: Props) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const startsAt = new Date(upcoming.starts_at).getTime();
  const msUntil = startsAt - now;

  if (msUntil <= 0 || msUntil > 60 * 60 * 1000) return null;

  const endsAt = new Date(upcoming.ends_at);
  const endsLabel = endsAt.toLocaleTimeString("pl-PL", { hour: "2-digit", minute: "2-digit" });

  return (
    <div className="w-full bg-red-600 text-white text-xs font-mono py-1.5 px-4 flex items-center gap-2 z-50 flex-shrink-0">
      <AlertTriangle size={14} className="flex-shrink-0" />
      <span className="font-semibold">
        {upcoming.is_deployment ? "Planowane wdrożenie nowej wersji:" : "Planowana przerwa techniczna:"}
      </span>
      <span>{upcoming.title}</span>
      <span className="opacity-80">
        {upcoming.is_deployment
          ? `— za około ${formatCountdownRough(msUntil)} (do około ${endsLabel})`
          : `— za ${formatCountdown(msUntil)} (do ${endsLabel})`}
      </span>
      {upcoming.message && (
        <span className="hidden sm:inline opacity-80 truncate">| {upcoming.message}</span>
      )}
    </div>
  );
}
